import { IsNotEmpty, IsString, MaxLength, IsOptional, MinLength, IsArray } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class PricelistEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    name: string;

    @IsOptional()
    @IsString()
    description: string;

    @IsNotEmpty()
    @IsString()
    @MinLength(3)
    @MaxLength(3)
    currency: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    items: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    accounts: Array<string>;

}
